import * as React from 'react';
import Stack from '@mui/material/Stack';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from '../../../shared-theme/ColorModeIconDropdown';
import { useUser } from '../../../AuthContext';
import { getTweetUsage } from '../../../api/GenerateAPI';
import { Box, Typography } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import Chip from '@mui/material/Chip';

export default function Header() {
  const { accessToken, isPaidUser } = useUser();
  const [tweetCount, setTweetCount] = React.useState(0);

  React.useEffect(() => {
    const fetchTweetUsage = async () => {
      try {
        const result = await getTweetUsage(accessToken);
        setTweetCount(result.usage_count);
      } catch (error) {
        console.error('Error fetching tweet usage:', error);
      }
    };

    fetchTweetUsage();
  }, [accessToken]);

  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <NavbarBreadcrumbs />
      <Stack direction="row" sx={{ gap: 1 }}>
      {isPaidUser ? <Chip style={{ marginTop: '0.5rem' }} label="Premium" color="success" /> : 
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          border: '1px solid',
          height: '2.25rem',
          borderColor: (theme) => theme.palette.divider,
          borderRadius: (theme) => theme.vars.shape.borderRadius,
          p: 1
        }}>
          <BoltIcon sx={{ color: 'warning.main' }} />
          <Typography variant="body2" color="text.secondary">
                {tweetCount}/50
              </Typography>
        </Box>
        }
        <ColorModeIconDropdown />
      </Stack>
    </Stack>
  );
}
